const overlappingImages = () => {
  const sections = document.querySelectorAll(".gr-section");

  sections.forEach((section) => {
    // check if sections sibling class is overlap-image
    if (
      section.nextElementSibling &&
      section.nextElementSibling.classList.contains("overlap-image")
    ) {
      section.classList.add("adjecent-image");
    }

    // check if section has an image
    if (section.classList.contains("overlap-image")) {
      // Get the image
      let img = section.querySelector("img");
      // Get the badge
      let badge = section.querySelector(".gr-badge");
      // Get the image's height
      let imgHeight = img.offsetHeight;
      console.log(img);
      console.log(img.getBoundingClientRect());
      console.log(imgHeight);
      // Add half the image's height to the padding-top of section
      badge.style.paddingTop = `${imgHeight / 2}px`;
      badge.style.marginTop = `${imgHeight / 2}px`;

      if (section.previousElementSibling.classList.contains("adjecent-image")) {
        section.previousElementSibling.querySelector(
          ".gr-badge"
        ).style.paddingBottom = `${imgHeight / 2}px`;
        section.style.marginTop = `-${imgHeight / 2}px`;
      }
    }
  });
};

export default overlappingImages;
